import React from 'react'
import { useHistory } from 'react-router'
import { HelpIcon } from '@Root/assets'
import styles from './style.module.scss'

export const HandbookHelp = () => {
  const history = useHistory()

  return (
    <button type='button' className={styles.button} onClick={() => history.push('/home/handbook')} aria-label='Open TEID Handbook' title='TEID Handbook'>
      <img src={HelpIcon} alt='' width={20} height={20} />
    </button>
  )
}
